<template>
    <div>
        <div :style="{display:isNextSearchDisp?'block':'none'}">
            <div :style="{display: 'flex',width:'100%',justifyContent:islargeSize?'center':'left',flexWrap:'wrap',}">
                <div :style="{display:isusersearch?'inline-block':'none'}" :class="sliderLength>0?'itemspace-wrap':'itemspace'">
                    <RadioGroup v-model="scene" @on-change="rgSwitch" type="button" button-style="solid" :size="islargeSize?'large':'default'">
                        <Radio label="政策法规"></Radio>
                        <Radio label="官方解答"></Radio>
                    </RadioGroup>
                </div>
                <div :class="sliderLength>0?'itemspace-wrap':'itemspace'" style="width: 30%;min-width: 170px;" :style="{flexBasis:islargeSize?'440px':(sliderLength>1&&src?'170px':'340px')}">
                    <Input class="inputbox" v-model="text" :maxlength="searchTextMaxlength" search enter-button="查询" @on-search="nextSearch" :placeholder="isRegulations?'当前区域适用法规查询':'请输入查询内容'" :size="islargeSize?'large':'default'">
                    </Input>
                </div>
                <div v-show="!isHidden_xl" :class="sliderLength>0?'itemspace-wrap':'itemspace'">
                    <SingleSelect ref='treeForceSelector' :class="islargeSize?(scene==='政策法规'?'common-width-large':'common-width-large-nobolder'):(scene==='政策法规'?'common-width':'common-width-nobolder')" :tData="sTreeData" @onClearText="onForceClearText" @tag-Select="getForceSelection"></SingleSelect>
                </div>
                <br />
                <div :class="sliderLength>0?'itemspace-wrap':'itemspace'">
                    <DatePicker class="datepicker" type="daterange" split-panels confirm format="yyyy-MM-dd" placement="bottom-end" placeholder="请选择时间范围" :editable="false" v-model="timeZone" :size="islargeSize?'large':'default'" @on-change="timeOnChange" @on-ok="datePickerOk" @on-clear="dateClear"></DatePicker>
                </div>
            </div>
        </div>
        <div :style="{display:isNextSearchDisp?'block':'none',height:'5px',lineHeight:'5px'}" />
    </div>
</template>
<script>
import store from '../../../store/'
import { mapGetters } from 'vuex'
import More from "../../../api/common/more.js"
import treeData2 from '../../../assets/json/select-tree2.json'
import TreeSingleselect from '../../common/tree-single-select.vue'
let MoreFun = new More()
export default {
    name: 'NextSearchBar2',
    props: {
        isHidden: Boolean, //默认是否显示
        islargeSize: {
            type: Boolean,
            default: false, ////组件size是否是large
        },
        src: {
            type: Boolean,
            default: false, //是否在云端
        },
        isHidden_xl: {
            type: Boolean,
            default: false, //是否显示效力，true=不显示，false=显示，解答版不显示效力
        }
    },
    data() {
        return {
            fileforce: {},
            sTreeData: this.getSelectTreeData(),
            isNextSearchDisp: this.isHidden,
            timeZone: ["", ""],
            text: "",
            searchTextMaxlength: 100,
            isRegulations: this.$router.history.current.name === 'localindex' ? true : false,
            scene: '政策法规',
            isusersearch: false,
        }
    },
    computed: {
        ...mapGetters(['sliderLength'])
    },
    mounted() {
        //console.log(this.scene)
        //console.log('router333===>',this.$router.history.current.name)
    },
    created() {
        console.log(this.$router.history.current.name)
        if (this.$router.history.current.name === 'usersearch') {
            this.isusersearch = true
        }
        //console.log("isNextSearchDisp:"+this.isNextSearchDisp)
    },
    components: {
        'SingleSelect': TreeSingleselect,
    },
    methods: {
        setDisable(value){
            if(value==='官方解答'){
                this.$refs.treeForceSelector.disabled=true
                this.$refs.treeForceSelector.setValue(null)
            }else{
                this.$refs.treeForceSelector.disabled=false
            }
        },
        rgSwitch(value) {
            console.log(value)
            this.scene=value
            //控制效力禁用状态
            this.setDisable(value)
            //控制左侧菜单禁用
            this.$emit('search-scene',value)
        },
        setTreeSelect(value) {
            //console.log('---+++++------'+value)
            this.$refs.treeForceSelector.setValue(value.id)
        },
        dateClear() {
            console.log('dateclearOk====>')
            this.timeZone = ["", ""]
            this.nextSearch()
        },
        datePickerOk() {
            console.log('datePickerOk====>')
            this.nextSearch()
        },
        getForceSelection(node) {
            this.fileforce = node
            console.log('getForceSelection==>')
            console.log(this.fileforce)
            this.nextSearch()
        },
        onForceClearText() {
            this.fileforce = {}
            this.nextSearch()
        },
        getSelectTreeData() {
            return treeData2.force
        },
        timeOnChange() {
            var time = []
            if (this.timeZone[0] !== "") {
                time[0] = MoreFun.getFormattedDate(this.timeZone[0])
                time[1] = MoreFun.getFormattedDate(this.timeZone[1])
                this.timeZone = time
                //this.$emit("on-time-change",this.timeZone)
            } else {

            }
        },

        getSearchCondition() {
            let searchCondition = {}
            searchCondition.time = this.timeZone
            searchCondition.text = this.text
            searchCondition.fileforce = this.fileforce
            return searchCondition
        },

        nextSearch() {
            let searchCondition = {}
            searchCondition.time = this.timeZone
            searchCondition.text = this.text
            searchCondition.fileforce = this.fileforce
            console.log(searchCondition)
            this.$emit('next-search', searchCondition)

        },
        display(isShow) {
            this.isNextSearchDisp = isShow
        },
        resetCondition() {
            console.log('nextSearchBar2,resetCondition=====>')
            console.log(this.fileforce)
            this.timeZone = []
            this.text = ""
            this.fileforce = {}
            this.$refs.treeForceSelector.value = null
        },
        getNextCondition() {
            let searchCondition = {}
            searchCondition.time = this.timeZone
            searchCondition.text = this.text
            searchCondition.fileforce = this.fileforce
            return searchCondition
        },
    }
}
</script>
<style lang="less" scoped>
.itemspace {
    padding: 2px 5px;
}

//1屏换行
.itemspace-wrap {
    padding: 2px 5px;
}

//2屏换行
.itemspace-wrap-last {
    padding: 2px 0px;
    width: 160px;
}

.common-width {
    width: 160px;

    /deep/ .vue-treeselect__control {
        height: 32px;
        line-height: 32px;
        border: 1px solid #2D8CF0 !important;
        border-radius: 4px;
    }

    /deep/ .vue-treeselect__single-value {
        margin-top: -2px;
    }

    /deep/ .vue-treeselect__placeholder {
        margin-top: -2px;
    }
}
.common-width-nobolder {
    width: 160px;

    /deep/ .vue-treeselect__control {
        height: 32px;
        line-height: 32px;
        //border: 1px solid #2D8CF0 !important;
        border-radius: 4px;
    }

    /deep/ .vue-treeselect__single-value {
        margin-top: -2px;
    }

    /deep/ .vue-treeselect__placeholder {
        margin-top: -2px;
    }
}

.common-width-large {
    width: 160px;

    /deep/ .vue-treeselect__control {
        height: 42px;
        line-height: 42px;
        border: 1px solid #2D8CF0 !important;
        border-radius: 4px;
    }

    /deep/ .vue-treeselect__single-value {
        margin-top: 3px;
    }

    /deep/ .vue-treeselect__placeholder {
        margin-top: 3px;
    }
}

.common-width-large-nobolder {
    width: 160px;

    /deep/ .vue-treeselect__control {
        height: 42px;
        line-height: 42px;
        //border: 1px solid #2D8CF0 !important;
        border-radius: 4px;
    }

    /deep/ .vue-treeselect__single-value {
        margin-top: 3px;
    }

    /deep/ .vue-treeselect__placeholder {
        margin-top: 3px;
    }
}



.inputbox {
    /deep/ .ivu-input {
        border: 1px solid #2D8CF0 !important;
        border-radius: 4px;
    }
}

.datepicker {
    width: 160px;

    /deep/ .ivu-input {
        border: 1px solid #2D8CF0 !important;
        border-radius: 4px;
    }
}

/*修改treeselect的height*/
/*#app /deep/ .vue-treeselect__control {
    height: 42px;
    line-height: 42px;
}*/

/*treeselect item*/
/*#app /deep/ .vue-treeselect__single-value {
    margin-top: 3px;
}*/

/*treeselect placeholder*/
/*#app /deep/ .vue-treeselect__placeholder {
    margin-top: 3px;
}*/





// .vue-treeselect__control{
//     border: 2px solid #2D8CF0;
// }
</style>
<style>
/*.ivu-input {
     border: 1px solid #2D8CF0 !important;
     border-radius: 4px;
}*/
</style>